const bgImages = [
  "https://images.metmuseum.org/CRDImages/as/original/DP141042.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP122128.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP122842.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140963.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140969.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140976.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140978.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140979.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140983.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140984.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140985.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140986.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140987.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP140992.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141061.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141120.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141121.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141122.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141123.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141124.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141125.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141126.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141127.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141128.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141228.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141229.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141231.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141235.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP141250.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP146847.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP148844.jpg",
  "https://images.metmuseum.org/CRDImages/as/original/DP273159.jpg",
];

export default bgImages;
